import { createNamespace } from '../utils';
import Avatar from '../avatar';
import Icon from '../icon';

var _createNamespace = createNamespace('call'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1];

export default createComponent({
  props: {
    mode: {
      type: String,
      default: 'voice'
    },
    avatarFigure: [Number, String],
    avatarSize: {
      type: [Number, String],
      default: 100
    },
    avatarRadius: {
      type: [Number, String],
      default: 6
    },
    title: String,
    tip: String,
    handFree: Boolean,
    count: String
  },
  computed: {
    isVoice: function isVoice() {
      return this.mode === 'voice';
    }
  },
  methods: {
    switchMode: function switchMode() {
      this.$emit('switchMode');
    },
    switchHandFree: function switchHandFree() {
      this.$emit('switchHandFree');
    },
    switchCamera: function switchCamera() {
      this.$emit('switchCamera');
    },
    hangUp: function hangUp() {
      this.$emit('hangUp');
    }
  },
  render: function render() {
    var h = arguments[0];
    var slots = this.slots,
        avatarFigure = this.avatarFigure,
        avatarSize = this.avatarSize,
        avatarRadius = this.avatarRadius,
        title = this.title,
        tip = this.tip,
        handFree = this.handFree,
        count = this.count,
        isVoice = this.isVoice,
        switchMode = this.switchMode,
        switchHandFree = this.switchHandFree,
        switchCamera = this.switchCamera,
        hangUp = this.hangUp;
    var genVoice = h("div", {
      "directives": [{
        name: "show",
        value: isVoice
      }],
      "class": bem('voice-box')
    }, [slots('avatar') || avatarFigure && h(Avatar, {
      "attrs": {
        "figure": avatarFigure,
        "size": avatarSize,
        "radius": avatarRadius
      }
    }), title && h("div", {
      "class": bem('title')
    }, [title]), tip && h("div", {
      "class": bem('tip')
    }, [tip]), slots('voice')]);
    var genVideo = h("div", {
      "directives": [{
        name: "show",
        value: !isVoice
      }],
      "class": bem('video-box')
    }, [slots('video')]);
    var genBottom = h("div", {
      "class": bem('bottom-box')
    }, [slots('bottom'), h("div", {
      "class": bem('count')
    }, [count]), h("div", {
      "class": bem('button-wrapper')
    }, [h("div", {
      "class": bem('button-cell')
    }, [h(Icon, {
      "attrs": {
        "name": isVoice ? 'vedio2' : 'music',
        "size": isVoice ? '30' : '36'
      },
      "class": bem('icon'),
      "on": {
        "click": switchMode
      }
    }), h("div", {
      "class": bem('button-text')
    }, ["\u5207\u6362", isVoice ? '视频' : '语音'])]), h("div", {
      "class": bem('button-cell')
    }, [h(Icon, {
      "attrs": {
        "name": "off-phone",
        "size": "35"
      },
      "class": bem('icon'),
      "on": {
        "click": hangUp
      }
    }), h("div", {
      "class": bem('button-text')
    }, ["\u6302\u65AD"])]), h("div", {
      "directives": [{
        name: "show",
        value: isVoice
      }],
      "class": bem('button-cell')
    }, [h(Icon, {
      "attrs": {
        "name": "volume2",
        "size": "36"
      },
      "class": bem('icon', {
        actived: handFree
      }),
      "on": {
        "click": switchHandFree
      }
    }), h("div", {
      "class": bem('button-text')
    }, [handFree ? '关闭' : '打开', "\u514D\u63D0"])]), h("div", {
      "directives": [{
        name: "show",
        value: !isVoice
      }],
      "class": bem('button-cell')
    }, [h(Icon, {
      "attrs": {
        "name": "photograph",
        "size": "36"
      },
      "class": bem('icon'),
      "on": {
        "click": switchCamera
      }
    }), h("div", {
      "class": bem('button-text')
    }, ["\u5207\u6362\u6444\u50CF\u5934"])])])]);
    return h("div", {
      "attrs": {
        "role": "call"
      },
      "class": bem()
    }, [genVoice, genVideo, genBottom]);
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant-green/es/call/index.js
// module id = null
// module chunks = 